import { SOFTWARE_INTEGRATION_WITH_FAIRE_ID } from "@faire/help-center-utils/articleIds";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalIntegrations from "@faire/web-api--source/routes/www/brand-portal/integrations";
import supportArticle from "@faire/web-api--source/routes/www/support/articles/articleId";
import React, { JSX } from "react";

import { Bold } from "../common/Bold";

export const SetUpIntegrationIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="To find available integrations, go to the <BoldFormatting>Settings</BoldFormatting> page in your brand portal then select <LinkFormatting>Integrations</LinkFormatting>. For tips on setting up your chosen integration with Faire, visit <ManagingIntegrationsArticleLinkFormatting>Managing Integrations on Faire</ManagingIntegrationsArticleLinkFormatting> and <SoftwareIntegrationArticleLinkFormatting>Software integration with Faire</SoftwareIntegrationArticleLinkFormatting>."
          values={{
            LinkFormatting: IntegrationsLinkFormatting,
            ManagingIntegrationsArticleLinkFormatting,
            SoftwareIntegrationArticleLinkFormatting,
            BoldFormatting,
          }}
          description={{
            text: "Introduction to setting up integrations",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="If you’re having trouble setting up an integration, contact our support team for further assistance."
          description={{
            text: "Conclusion for setting up integrations",
          }}
        />
      </Typography>
    </Column>
  );
};

const IntegrationsLinkFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalIntegrations()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const ManagingIntegrationsArticleLinkFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={supportArticle("4409994540571")}
    target="_blank"
  >
    {chunks}
  </Button>
);

const SoftwareIntegrationArticleLinkFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={supportArticle(SOFTWARE_INTEGRATION_WITH_FAIRE_ID)}
    target="_blank"
  >
    {chunks}
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
